var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect, _rect2, _circle, _circle2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _circle3, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _rect12, _path45, _path46, _path47, _path48, _path49, _path50, _rect13, _rect14, _rect15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "60769e6b-e02c-46d5-b3c8-af0a841291ce",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 961.07,
    height: 805.46,
    viewBox: "0 0 961.07 805.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b90cb4e4-a219-4e38-82be-672120cec5cc",
    x1: 516.59,
    y1: 775.99,
    x2: 516.59,
    y2: 47.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fe4ca1d0-4ba6-4fc9-a7d7-fc6682b340d3",
    x1: 802.23,
    y1: 799.75,
    x2: 802.23,
    y2: 247.72,
    xlinkHref: "#b90cb4e4-a219-4e38-82be-672120cec5cc"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "app installation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.87,71.42c-36.14,6.47-77.64,18-92.26,53.45-13.36,32.41,2.32,68.92,12.87,102.46a348.56,348.56,0,0,1,16,102.3c.27,48.82-9.24,100.3,10.08,144.66,21.8,50.05,75.75,79,94.66,130.3,7.93,21.51,8.89,45.05,12.67,67.78,8.38,50.37,31.27,97.94,64.87,134.79,22.34,24.5,51.43,45.06,83.65,45.55,24.44.38,47.52-10.71,70.16-20.42a713.56,713.56,0,0,1,81.07-29.1c11.62-3.39,23.59-6.51,35.61-5.45,23.16,2,42.48,19,64.46,27,59.57,21.6,121.15-25.34,184-30.29,53.88-4.25,108,22.84,160.94,11.53,7.8-1.67,16.14-4.7,20.23-11.9,6.77-11.93-1.63-28.44,4.39-40.81s22.27-13.65,31.81-23.06c9.71-9.58,10.5-26.12,5.55-39.13s-14.5-23.37-23.68-33.5A1436.48,1436.48,0,0,1,928.76,498c-38.68-57.19-74.88-124.46-64-193.77,3.76-23.85,13-46.42,17.19-70.19s2.47-50.69-12.9-68.63c-9.18-10.72-22.06-16.91-34.56-22.81C717.91,87.57,593,31.22,466.78,52.05c-20.55,3.39-40.89,8.83-61.68,9.57-30.09,1.08-58.41-12.37-87.8-8C283.93,58.55,250.21,65.45,216.87,71.42Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#35979C",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M309.08,218.12s-41.13-22.58-53.33-57.17a71.09,71.09,0,0,0-27.37-35.69,119.57,119.57,0,0,0-19.24-10.4",
    transform: "translate(-119.47 -47.27)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M201.34,93.11c3.89,3.91,8.08,22.3,8.08,22.3s-18.36-4.3-22.25-8.22a10,10,0,0,1,14.17-14.08Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#35979C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M234.59,103.14c1.14,5.4-5.33,23.11-5.33,23.11s-13.07-13.59-14.21-19a10,10,0,0,1,19.55-4.12Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#35979C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M270.89,140.68c-1.74,5.23-16.27,17.26-16.27,17.26s-4.42-18.33-2.68-23.57a10,10,0,1,1,19,6.31Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#35979C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M292,175.27c-.83,5.45-13.12,19.76-13.12,19.76s-7.46-17.32-6.63-22.77a10,10,0,1,1,19.75,3Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#35979C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M215.14,141.8c5.52-.06,21.4-10.24,21.4-10.24s-16.11-9.8-21.63-9.74a10,10,0,0,0,.23,20Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#35979C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M240.29,181.94c5.24-1.71,17.35-16.17,17.35-16.17s-18.31-4.53-23.55-2.82a10,10,0,0,0,6.2,19Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#35979C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M270.09,217.6c5.46-.8,19.84-13,19.84-13s-17.28-7.56-22.73-6.76a10,10,0,1,0,2.9,19.77Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#35979C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M272.08,356.12s-41.13-22.58-53.33-57.17a71.09,71.09,0,0,0-27.37-35.69,119.57,119.57,0,0,0-19.24-10.4",
    transform: "translate(-119.47 -47.27)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M164.34,231.11c3.89,3.91,8.08,22.3,8.08,22.3s-18.36-4.3-22.25-8.22a10,10,0,0,1,14.17-14.08Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#35979C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M197.59,241.14c1.14,5.4-5.33,23.11-5.33,23.11s-13.07-13.59-14.21-19a10,10,0,0,1,19.55-4.12Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#35979C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M233.89,278.68c-1.74,5.23-16.27,17.26-16.27,17.26s-4.42-18.33-2.68-23.57a10,10,0,1,1,19,6.31Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#35979C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M255,313.27c-.83,5.45-13.12,19.76-13.12,19.76s-7.46-17.32-6.63-22.77a10,10,0,1,1,19.75,3Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#35979C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M178.14,279.8c5.52-.06,21.4-10.24,21.4-10.24s-16.11-9.8-21.63-9.74a10,10,0,0,0,.23,20Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#35979C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M203.29,319.94c5.24-1.71,17.35-16.17,17.35-16.17s-18.31-4.53-23.55-2.82a10,10,0,1,0,6.2,19Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#35979C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M233.09,355.6c5.46-.8,19.84-13,19.84-13s-17.28-7.56-22.73-6.76a10,10,0,1,0,2.9,19.77Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#35979C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M748.88,47.27H284.31a42.56,42.56,0,0,0-42.62,42.5V733.49A42.56,42.56,0,0,0,284.31,776H748.88a42.56,42.56,0,0,0,42.62-42.5V89.76A42.56,42.56,0,0,0,748.88,47.27Z",
    transform: "translate(-119.47 -47.27)",
    fill: "url(#b90cb4e4-a219-4e38-82be-672120cec5cc)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 128.77,
    y: 8.73,
    width: 536.72,
    height: 713.44,
    rx: 20,
    ry: 20,
    fill: "#535461"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 156.04,
    y: 76.22,
    width: 482.18,
    height: 578.47,
    fill: "#f1f1f4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 394.95,
    cy: 41.45,
    r: 6.55,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 394.95,
    cy: 687.26,
    r: 19.64,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 214.13,
    y: 151.36,
    width: 94,
    height: 94,
    rx: 11.85,
    ry: 11.85,
    fill: "#35979C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 605.59,
    y: 198.63,
    width: 94,
    height: 94,
    rx: 11.85,
    ry: 11.85,
    transform: "translate(1185.72 443.99) rotate(-180)",
    fill: "#35979C",
    opacity: 0.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 350.13,
    y: 151.36,
    width: 94,
    height: 94,
    rx: 11.85,
    ry: 11.85,
    fill: "#35979C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 214.13,
    y: 317.36,
    width: 94,
    height: 94,
    rx: 11.85,
    ry: 11.85,
    fill: "#35979C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 605.59,
    y: 364.63,
    width: 94,
    height: 94,
    rx: 11.85,
    ry: 11.85,
    transform: "translate(1185.72 775.99) rotate(-180)",
    fill: "#35979C",
    opacity: 0.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 350.13,
    y: 317.36,
    width: 94,
    height: 94,
    rx: 11.85,
    ry: 11.85,
    fill: "#35979C",
    opacity: 0.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 214.13,
    y: 483.36,
    width: 94,
    height: 94,
    rx: 11.85,
    ry: 11.85,
    fill: "#35979C"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 605.59,
    y: 530.63,
    width: 94,
    height: 94,
    rx: 11.85,
    ry: 11.85,
    transform: "translate(1185.72 1107.99) rotate(-180)",
    fill: "#35979C"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 350.13,
    y: 483.36,
    width: 94,
    height: 94,
    rx: 11.85,
    ry: 11.85,
    fill: "#35979C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M909.49,325.17a7.87,7.87,0,0,0-1.19-3,17.4,17.4,0,0,0-2.35-2.27c-4.72-4.44-2.18-12.44-4-18.61-2-6.59-9-11.64-15.08-15a12.19,12.19,0,0,0-3.14-1.27,26.21,26.21,0,0,0-4.16-.33,20,20,0,0,1-6.34-1.44c-2.89-1.18-5.47-3-8.43-4A4.29,4.29,0,0,0,863,279c-3.23-.3-3.34,3.72-6.81,6.05-1.44,1-2.81,2.38-2.81,4.1,0,2.35,2.4,3.9,4.54,4.93s2.63.83,3.05.82h.18c.29.05.61.3,1.44,1.21A27.37,27.37,0,0,0,839.44,323a26.81,26.81,0,0,0,2.35,11c-.09.64-.19,1.3-.3,2-1.05,6.45-3,14.23-6.34,20.67-2.74.56-4.47,1-4.47,1a2.56,2.56,0,0,1,.05.4l-1,.74-4.2,3c-8.27-13.71-16.72-30.73-17.06-43.51,0,0-1,.69-2.7,1.77v-9.08l-.54-.1.54-1,3.9-7.38a19.93,19.93,0,0,0,2.31-9c.18-11.6-.2-40.2-8.22-44.95-10.11-6-12.13,19.94-17.52,33.23-4,9.91-2,24.27-.78,30.92.09.45.17.86.25,1.24a75.62,75.62,0,0,0-9.57,4.39c2.13.84,3.72,7.51,4.6,12.31.09.51.18,1,.26,1.45a49.71,49.71,0,0,1-6.21,1.52l17.38,37.92c-3.71,4.3-11.45,11.83-17.38,7.93-8.09-5.32-33-2.66-33-2.66S727.55,339,728.23,327.68c0,0-.75.38-2,1V318.37a11.32,11.32,0,0,1-1.45.83l.53-.94.77-1.37a20.17,20.17,0,0,0,2.56-8.46c.84-11.63,2.07-41.49-7.13-45.22-11.46-4.65-14.83,28.57-14.83,28.57l2.44,30.08.05.67c-5.44.48-9.91.48-9.91.48,1.37,1.35,1.81,8.8,2,13.47,0,.48,0,.92,0,1.33-2.78.48-5.16.52-6.71-.18l18.2,49.17s1.35,12,24.94,17.28c13.87,3.13,23.54,6,29.16,7.88-9.62,22.8-43,105-33.21,125,0,0,5.24-2,10.6-3.76,1.24,17.24,3.39,43.35,6,60.08-2.85,8.81-5,16.2-5.7,20.43-.06.35-.11.68-.15,1-2,15.95-18.2,46.52,6.07,72.43,0,0,16.85,10,18.2,21.93,1.13,10.06,18.94,35.14,24.58,42.88-4.51,7.75-17.23,28.19-28.63,33.54-14.15,6.65-2.7,15.95,10.78,14s58-33.89,58-33.89-.31-20.88-4.53-22.4h0l-4.05-8.36a30,30,0,0,0,6.56-1.8c18.2-7.31,43.14-20.6,43.14-20.6s.49-15.61-6.58-21.33c-3.62-11.17-20.38-21.2-20.38-21.2S835.4,638.66,805.74,630c0,0-4.79-6.75-4.61-14.48,1.95-3.74,3.27-6.12,3.27-6.12L819.74,573a49.66,49.66,0,0,0,10-12.31q.34-.62.66-1.25c9.25,1.09,16.5,2.18,16.5,2.18l-.67-31.9C840.12,463.9,859,444.63,859,444.63s27-32.56,29.66-55.82c2.49-21.47-15.69-22.55-18.5-22.59a23.73,23.73,0,0,1,.35-9.58l.32.23a3.75,3.75,0,0,0,2,.83,2.3,2.3,0,0,0,.44,0l.24,0a3.9,3.9,0,0,0,1.87-.58c7.05-3.7,12.54-10.39,20.28-12.32,1.62-.4,3.31-.58,4.9-1.1a13.63,13.63,0,0,0,8-7.5A18.12,18.12,0,0,0,909.49,325.17Zm-99,352c1.35,4.65,22.92,20.6,22.92,20.6l.83,5.73a204,204,0,0,1-17.43,14.75l-7.67-15.83s-11.46-36.55-21.57-40.53c-1.87-.74-2.47-3-2.21-6.17C791.93,660.53,809.37,673.44,810.46,677.2Z",
    transform: "translate(-119.47 -47.27)",
    fill: "url(#fe4ca1d0-4ba6-4fc9-a7d7-fc6682b340d3)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M770.28,407.83s-45.84,106.08-34.71,129c0,0,18.34-7.2,21-5.89s28.81-136.86,28.81-136.86Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#575988"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M770.28,407.83s-45.84,106.08-34.71,129c0,0,18.34-7.2,21-5.89s28.81-136.86,28.81-136.86Z",
    transform: "translate(-119.47 -47.27)",
    opacity: 0.05
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M795.16,745.72s-15.72,29.47-29.47,36-2.62,15.72,10.48,13.75,56.32-33.4,56.32-33.4-.3-20.57-4.41-22.07S795.16,745.72,795.16,745.72Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#575988"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M836.42,697.92s-22.26,22.26-32.09,24.23,8.51,15.06,26.19,7.86,41.91-20.3,41.91-20.3.65-21-10.48-22.92S836.42,697.92,836.42,697.92Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#575988"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M744.74,515.87s4.58,79.89,10.48,91,28.16,45.18,28.16,45.18,25.54,18.34,26.85,22.92,22.26,20.3,22.26,20.3l1.31,9.17s34.71-2,32.74-13.75-20.3-22.92-20.3-22.92-11.79-30.78-40.6-39.29c0,0-9.17-13.1-1.31-23.57,0,0,19.65-49.11,30.78-55S830.52,510,830.52,510Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#67647e"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M744.74,515.87s4.58,79.89,10.48,91,28.16,45.18,28.16,45.18,25.54,18.34,26.85,22.92,22.26,20.3,22.26,20.3l1.31,9.17s34.71-2,32.74-13.75-20.3-22.92-20.3-22.92-11.79-30.78-40.6-39.29c0,0-9.17-13.1-1.31-23.57,0,0,19.65-49.11,30.78-55S830.52,510,830.52,510Z",
    transform: "translate(-119.47 -47.27)",
    opacity: 0.05
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M808.91,699.88l21,43.87c-3.27,11.13-34.71,7.2-34.71,7.2s-24.23-32.74-25.54-44.53-17.68-21.61-17.68-21.61c-23.57-25.54-7.86-55.66-5.89-71.38,0-.3.09-.63.14-1,1.74-10.54,12.34-40.86,20.58-63.57,5.56-15.3,10.05-27.14,10.05-27.14s43.87,2,53,17.68c4.2,7.2,2.32,14.69-.95,20.69a48.77,48.77,0,0,1-9.68,12.13l-14.91,35.94S778.14,656,788,659.94,808.91,699.88,808.91,699.88Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#67647e"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M730.71,311.6a20.08,20.08,0,0,1-2.48,8.34l-.75,1.35-3.69,6.65H712l-.25-3.1-2.37-29.64s3.27-32.74,14.41-28.16C732.72,270.72,731.53,300.14,730.71,311.6Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#f7c4a7"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M727.48,321.28l-3.69,6.65H712l-.25-3.1C717.24,324.35,723.77,323.35,727.48,321.28Z",
    transform: "translate(-119.47 -47.27)",
    opacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M728.37,321.39v15.06L704.14,343s0-1.57-.07-3.75c-.14-4.6-.57-11.94-1.9-13.27C702.18,326,721.82,326,728.37,321.39Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#e6e6f0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M728.37,330.22v6.23L704.14,343s0-1.57-.07-3.75C712.14,337.84,723.79,332.45,728.37,330.22Z",
    transform: "translate(-119.47 -47.27)",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M869.69,355.07c-4.78,13.8,1.43,20,1.43,20s-58.94,3.93-44.53-6.55c8.41-6.12,12.14-19.62,13.78-29.78A101.56,101.56,0,0,0,841.66,326s47.1-.69,37.33,12.44A63,63,0,0,0,869.69,355.07Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#f7c4a7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M879,338.41c-4.8,6.46-6.37,7.41-8,12.07a26.33,26.33,0,0,1-4.46.37c-11.23,0-22.16-2.31-26.17-12.1A101.56,101.56,0,0,0,841.66,326S888.75,325.28,879,338.41Z",
    transform: "translate(-119.47 -47.27)",
    opacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 745.76,
    cy: 278.7,
    r: 26.85,
    fill: "#f7c4a7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M730.33,330.55s-25.54,13.1-32.74,9.82l17.68,48.46s1.31,11.79,24.23,17,34.05,9.82,34.05,9.82l42.56-50.42-21.61,5.89s-11.13,15.72-19,10.48S743.43,379,743.43,379,729.68,341.69,730.33,330.55Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#575988"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M730.33,330.55s-25.54,13.1-32.74,9.82l17.68,48.46s1.31,11.79,24.23,17,34.05,9.82,34.05,9.82l42.56-50.42-21.61,5.89s-11.13,15.72-19,10.48S743.43,379,743.43,379,729.68,341.69,730.33,330.55Z",
    transform: "translate(-119.47 -47.27)",
    opacity: 0.05
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M829.87,361.47s34.62-9.9,38.26,8.49c0,0-16-7.8-38.92,6-1.72,1-3.4,2.13-5,3.28-20.17,14.13-34.26,36-39.92,60.84l-14.63,64.1-1.31,17.23s-21,4.14-24.88-2.07-1.31-26.89,4.58-33.78S763.08,449,763.08,449l5.73-17.2a115,115,0,0,1,22.43-39.33h0l1.38-1.67a86,86,0,0,1,31.93-23.88C827.9,365.47,830.33,363.64,829.87,361.47Z",
    transform: "translate(-119.47 -47.27)",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M829.87,360.16s34.62-9.9,38.26,8.49c0,0-16-7.8-38.92,6-1.72,1-3.4,2.13-5,3.28-20.17,14.13-34.26,36-39.92,60.84l-14.63,64.1-1.31,17.23s-21,4.14-24.88-2.07-1.31-26.89,4.58-33.78,15.06-36.54,15.06-36.54l5.73-17.2a115,115,0,0,1,22.43-39.33h0l1.38-1.67a86,86,0,0,1,31.93-23.88C827.9,364.16,830.33,362.33,829.87,360.16Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#e6e6f0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M742.81,492.16l.29,11.28,9.17-5.89s16.33-59.43,27.83-75.63c1.35-1.91,2-4.76,3.27-5.24l46.82-45.18V361s-23.9,17.68-25.87,21c-.84,1.39-13.39,8.25-21,19a237.38,237.38,0,0,0-18,31.1l-15.72,35.36Z",
    transform: "translate(-119.47 -47.27)",
    opacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M830.2,360.35V370.5L782.72,416c-1.26.48-1.92,3.33-3.27,5.24-11.51,16.21-27.83,75.63-27.83,75.63l-9.17,5.89-.29-11.28L749,466.76l15.72-35.36a237.32,237.32,0,0,1,18-31.1c7.56-10.74,20.12-17.6,21-19,1.7-2.82,20.16-16.34,25.24-20Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#787c9c"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M856.29,297.47c-2.07-1-4.41-2.55-4.41-4.86,0-1.69,1.33-3.09,2.73-4,3.74-2.55,3.45-7.16,7.75-5.72,2.88,1,5.39,2.79,8.19,3.95a19.17,19.17,0,0,0,6.16,1.42,25.11,25.11,0,0,1,4,.32,11.75,11.75,0,0,1,3,1.25,26.3,26.3,0,0,1,12.36,15.43c1.78,6.08,1.6,13.28,6.18,17.65a17,17,0,0,1,2.28,2.23,7.82,7.82,0,0,1,1.15,3,18.1,18.1,0,0,1-.9,10.87,13.32,13.32,0,0,1-7.81,7.39c-1.55.51-3.18.68-4.76,1.08-7.52,1.9-12.85,8.5-19.71,12.14a3.76,3.76,0,0,1-1.82.57,3.62,3.62,0,0,1-1.92-.82c-2.65-1.89-4.83-4.83-4.76-8.09a16.36,16.36,0,0,1,1.75-5.83,56.5,56.5,0,0,0,3.28-10.55,5.14,5.14,0,0,0,.07-2.55c-.5-1.59-2.26-2.33-3.48-3.46-2.32-2.15-2.6-5.81-1.74-8.86s2.66-5.74,4-8.61a6.78,6.78,0,0,0,.79-2.79c0-3.83-5.18-5.91-7.36-8.44C858.47,296.73,860.34,299.47,856.29,297.47Z",
    transform: "translate(-119.47 -47.27)",
    opacity: 0.1
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M856.95,297.47c-2.07-1-4.41-2.55-4.41-4.86,0-1.69,1.33-3.09,2.73-4,3.74-2.55,3.45-7.16,7.75-5.72,2.88,1,5.39,2.79,8.19,3.95a19.17,19.17,0,0,0,6.16,1.42c1.35.08,5.72-2,7-1.68a11.75,11.75,0,0,1,3,1.25,26.3,26.3,0,0,1,12.36,15.43c1.78,6.08.54,13.68,5.12,18,.77.74-.28,3,.34,3.83a7.82,7.82,0,0,1,1.15,3,18.1,18.1,0,0,1-.9,10.87,13.32,13.32,0,0,1-7.81,7.39c-1.55.51-3.18.68-4.76,1.08-7.52,1.9-12.85,8.5-19.71,12.14a3.76,3.76,0,0,1-1.82.57,3.62,3.62,0,0,1-1.92-.82c-2.65-1.89-4.83-4.83-4.76-8.09a16.36,16.36,0,0,1,1.75-5.83,56.5,56.5,0,0,0,3.28-10.55,5.14,5.14,0,0,0,.07-2.55c-.5-1.59-2.26-2.33-3.48-3.46-2.32-2.15-2.6-5.81-1.74-8.86s2.66-5.74,4-8.61a6.78,6.78,0,0,0,.79-2.79c0-3.83-5.18-5.91-7.36-8.44C859.13,296.73,861,299.47,856.95,297.47Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#b96b6b"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M828.92,560.14c-12-1.42-27.12-2.81-33.76-1.7-10.69,1.78-25.69-7.75-28.39-9.53,5.56-15.3,10.05-27.14,10.05-27.14s43.87,2,53,17.68C834.07,546.65,832.19,554.14,828.92,560.14Z",
    transform: "translate(-119.47 -47.27)",
    opacity: 0.1
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M886.19,390.8c-2.62,22.92-28.81,55-28.81,55s-18.34,19-12.44,83.82l.65,31.43s-38.64-5.89-50.42-3.93-28.81-9.82-28.81-9.82S759.8,434,788,410.45A166.34,166.34,0,0,1,799.28,395c7.56-9.15,17.84-19.46,27.46-22a17.18,17.18,0,0,1,3.79-.58s29.47-16.37,37.33-3.93C867.85,368.54,888.8,367.88,886.19,390.8Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#575988"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M766.68,512.93s10.48-4.58,28.16-3.27S844,495.25,844,495.25",
    transform: "translate(-119.47 -47.27)",
    opacity: 0.1
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M785.67,659s.65,2-7.86,4.58-11.13,5.24-11.13,5.24",
    transform: "translate(-119.47 -47.27)",
    opacity: 0.05
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 712.94,
    y: 212.27,
    width: 94,
    height: 94,
    rx: 11.85,
    ry: 11.85,
    transform: "translate(1400.41 471.27) rotate(-180)",
    fill: "#35979C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M811.66,296.92a19.87,19.87,0,0,1-2.24,8.88l-3.78,7.28-2.62,5-16.37,1.31s-.34-1.35-.76-3.58c-1.22-6.55-3.15-20.7.76-30.47,5.24-13.1,7.2-38.64,17-32.74C811.47,257.3,811.84,285.49,811.66,296.92Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#f7c4a7"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M805.64,312.87v.2l-2.62,5-16.37,1.31s-.34-1.35-.76-3.58C791.75,313.57,799.43,311.49,805.64,312.87Z",
    transform: "translate(-119.47 -47.27)",
    opacity: 0.1
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M805.64,314.18V326l-23.57,12.44s-.27-2.13-.77-4.89c-.86-4.73-2.4-11.31-4.47-12.13C776.83,321.39,793.85,311.56,805.64,314.18Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#e6e6f0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M869.4,421.22A27.74,27.74,0,0,1,848.22,428c-41.46-4.21-42.58-18.86-42.58-18.86L799.28,395c7.56-9.15,17.84-19.46,27.46-22,6.87,11.07,13,19.06,13,19.06s30.78-23.57,39.95-1.31C885,403.76,877,414.51,869.4,421.22Z",
    transform: "translate(-119.47 -47.27)",
    opacity: 0.05
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M805.64,321.4V326l-23.57,12.44s-.27-2.13-.77-4.89C791.46,330.26,801.51,324.09,805.64,321.4Z",
    transform: "translate(-119.47 -47.27)",
    opacity: 0.1
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M808.26,321.39s-17.68,12.44-32.74,15.06l30.78,68.1s1.13,14.65,42.58,18.86a27.75,27.75,0,0,0,21.17-6.78c7.6-6.71,15.58-17.46,10.24-30.42-9.17-22.26-39.95,1.31-39.95,1.31S808.91,346.27,808.26,321.39Z",
    transform: "translate(-119.47 -47.27)",
    fill: "#575988"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 790.7,
    y: 714.35,
    width: 156,
    height: 14,
    rx: 2.67,
    ry: 2.67,
    fill: "#35979C"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 773.7,
    y: 700.35,
    width: 156,
    height: 14,
    rx: 2.67,
    ry: 2.67,
    fill: "#35979C"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 773.7,
    y: 700.35,
    width: 156,
    height: 14,
    rx: 2.67,
    ry: 2.67,
    opacity: 0.05
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/integration.5f837d6cd6d89935cef03ae407316a15.svg";
export { ForwardRef as ReactComponent };